<style>
  /* Ticket for the 80mm thermal printer (Bixolon BK3-31: 72mm printable, 203 dpi, black only).
     On screen it is laid out off-screen so its height can be measured for the @page size. */
  .print-receipt {
    position: absolute;
    left: -10000px;
    top: 0;
    visibility: hidden;
    width: 72mm;
    padding: 2mm 0 3mm;
    font-family: Arial, Helvetica, sans-serif;
    color: #000;
    text-align: center;
  }
  @media print {
    .no-print {
      display: none !important;
    }
    .print-receipt {
      position: static;
      visibility: visible;
      margin: 0 auto;
      break-inside: avoid;
    }
  }
  .print-receipt .logos {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2mm;
  }
  .print-receipt .logos img {
    height: 16mm;
    width: auto;
    max-width: 34mm;
    object-fit: contain;
    filter: grayscale(1) contrast(1.2);
  }
  .print-receipt .small {
    font-size: 11px;
    text-transform: uppercase;
  }
  .print-receipt .comune {
    font-size: 18px;
    font-weight: bold;
  }
  .print-receipt .portal {
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1mm;
  }
  .print-receipt hr {
    border: none;
    border-top: 1px dashed #000;
    margin: 2.5mm 0;
  }
  .print-receipt hr.solid {
    border-top: 2px solid #000;
  }
  .print-receipt .confirmed {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
  }
  .print-receipt .row {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }
  .print-receipt .label {
    font-size: 12px;
    text-transform: uppercase;
    margin-top: 1.5mm;
  }
  .print-receipt .weekday {
    font-size: 20px;
    font-weight: bold;
  }
  .print-receipt .day-month {
    font-size: 30px;
    font-weight: 800;
    line-height: 1.1;
  }
  .print-receipt .year {
    font-size: 18px;
    font-weight: bold;
  }
  .print-receipt .time {
    font-size: 52px;
    font-weight: 800;
    line-height: 1.1;
    border: 3px solid #000;
    border-radius: 6px;
    margin: 1mm 4mm 0;
    padding: 1mm 0;
  }
  .print-receipt .note {
    font-size: 13px;
    line-height: 1.35;
    margin: 0;
  }
  .print-receipt .printed {
    font-size: 11px;
  }
</style>

<!-- On-screen confirmation -->
<div class="no-print flex justify-center items-start p-8">
  <div class="bg-white shadow rounded-2xl max-w-3xl w-full p-10 text-center">
    <div class="mx-auto mb-6 h-16 w-16 rounded-full bg-green-100 flex items-center justify-center">
      <span class="text-3xl">✓</span>
    </div>
    <h1 class="text-3xl font-extrabold mb-2">{{ 'appointment.confirmation.title' | translate }}</h1>
    <p class="text-gray-500 mb-8">{{ 'appointment.confirmation.subtitle' | translate }}</p>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 border-t pt-6">
      <div class="rounded-xl border p-4">
        <div class="text-sm text-gray-500 mb-2">{{ 'appointment.confirmation.date' | translate }}</div>
        <div class="font-semibold">{{ formatDate(state?.appointment?.from) }}</div>
      </div>
      <div class="rounded-xl border p-4">
        <div class="text-sm text-gray-500 mb-2">{{ 'appointment.confirmation.time' | translate }}</div>
        <div class="font-semibold">{{ formatTime(state?.appointment?.from) }}</div>
      </div>
      <div class="rounded-xl border p-4">
        <div class="text-sm text-gray-500 mb-2">{{ 'appointment.confirmation.location' | translate }}</div>
        <div class="font-semibold">{{ state?.appointment?.waitingRoom || '-' }}</div>
      </div>
    </div>

    <div class="mt-10 border rounded-xl p-8">
      <div class="mx-auto h-20 w-20 rounded-full border-4 border-gray-300 flex items-center justify-center text-3xl font-bold">
        {{ countdown }}
      </div>
      <p class="mt-4 text-gray-600">{{ 'appointment.confirmation.returning' | translate: { count: countdown } }}</p>
      <button class="mt-6 px-4 py-2 rounded bg-black text-white" (click)="goHome()">
        {{ 'appointment.confirmation.goNow' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Printed ticket (80mm). No citizen name: walk-in bookings are anonymous (point 3).
     Previous receipt rows: First Name / Booking for / Date / Time -->
<div #receipt class="print-receipt">
  <div class="logos">
    <img *ngIf="municipality?.coatOfArms" [src]="municipality?.coatOfArms" alt="" />
    <img *ngIf="municipality?.auslLogo" [src]="municipality?.auslLogo" alt="" />
  </div>
  <div class="small">{{ 'appointment.booking.header.comuneDi' | translate }}</div>
  <div class="comune">{{ municipalityName }}</div>
  <div class="portal">{{ 'appointment.booking.header.portal' | translate }}</div>

  <hr class="solid" />
  <div class="confirmed">{{ 'appointment.confirmation.ticket.confirmed' | translate }}</div>
  <hr />

  <div class="row">
    <span>{{ 'appointment.confirmation.ticket.location' | translate }}</span>
    <strong>{{ municipalityName }}</strong>
  </div>
  <hr />

  <div class="label">{{ 'appointment.confirmation.ticket.date' | translate }}</div>
  <div class="weekday">{{ ticketDate('weekday') }}</div>
  <div class="day-month">{{ ticketDate('dayMonth') }}</div>
  <div class="year">{{ ticketDate('year') }}</div>

  <div class="label">{{ 'appointment.confirmation.ticket.time' | translate }}</div>
  <div class="time">{{ formatTime(state?.appointment?.from) }}</div>

  <hr class="solid" />
  <p class="note" [innerHTML]="'appointment.confirmation.ticket.note' | translate"></p>
  <hr />
  <div class="printed">
    {{ 'appointment.confirmation.ticket.printedAt' | translate: { date: printedAt.format('DD/MM/YYYY'), time: printedAt.format('HH:mm') } }}
  </div>
</div>
